import React from 'react';
import { Box, Flex } from '@chakra-ui/react';

export const SIDEBAR_COLLAPSED_WIDTH = 70;
export const COLLAPSED_ICON_SIZE = 44;

/** Fila del menú colapsado: centra el hijo en los 70px del sidebar */
export function CollapsedSidebarItem({ children }) {
  return (
    <Flex
      w={`${SIDEBAR_COLLAPSED_WIDTH}px`}
      maxW={`${SIDEBAR_COLLAPSED_WIDTH}px`}
      minW={`${SIDEBAR_COLLAPSED_WIDTH}px`}
      justify="center"
      align="center"
      flexShrink={0}
    >
      {children}
    </Flex>
  );
}

/** Botón cuadrado 44px — forwardRef para Popover/Menu (Popper necesita el nodo real) */
export const CollapsedIconButton = React.forwardRef(function CollapsedIconButton(
  { children, ...props },
  ref,
) {
  return (
    <Box
      ref={ref}
      as="button"
      type="button"
      display="flex"
      alignItems="center"
      justifyContent="center"
      w={`${COLLAPSED_ICON_SIZE}px`}
      h={`${COLLAPSED_ICON_SIZE}px`}
      minW={`${COLLAPSED_ICON_SIZE}px`}
      minH={`${COLLAPSED_ICON_SIZE}px`}
      p={0}
      border="none"
      borderRadius="12px"
      lineHeight={0}
      cursor="pointer"
      {...props}
    >
      {children}
    </Box>
  );
});

export const collapsedIconInnerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: '20px',
  h: '20px',
  '& svg, & .chakra-icon': {
    w: '20px !important',
    h: '20px !important',
  },
};
